import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import { otherButtonsStyle as style } from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { scaleFloorPlanAction } from 'actions/floorPlanActions'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'

const mapStateToProps = ({ currentEntity, map: { floorPlans } }) => {
  return {
    currentEntity,
    floorplan: currentEntity.type === 'floorPlan' && floorPlans.find(f => f.id === currentEntity.id)
  }
}

const floorPlanButtons = ({ openFloorplan, floorplan, scaleFloorPlanAction, classes }) =>
  <div className={classes.bottomBar}>
    <div className={classes.buttonWrapper}>
      <div onClick={openFloorplan} className={classes.buttonRight}>
        <FontAwesomeIcon icon='pen' className={classes.icon} />
        Edit
      </div>
      <div onClick={_ => {
        floorplan.overlay.map.fitBounds(floorplan.overlay.getBounds())
        scaleFloorPlanAction(floorplan.id)
      }} className={classes.button}>
        <FontAwesomeIcon icon='expand-arrows-alt' className={classes.icon} />
        Scale
      </div>
    </div>
  </div>

const editEntityButton = ({ open, buttonLabel, currentEntity, classes }) =>
  <div className={classes.bottomBar}>
    <div className={classes.buttonWrapper}>
      <div onClick={open} className={classes.button}>
        <FontAwesomeIcon icon='pen' className={classes.icon} />
        Edit { buttonLabel || capitalizeFirstLetter(currentEntity.type) }
      </div>
    </div>
  </div>

export const FloorPlanButtons = connect(mapStateToProps, { scaleFloorPlanAction })(injectSheet(style)(floorPlanButtons))
export const EditEntityButton = connect(mapStateToProps)(injectSheet(style)(editEntityButton))



// WEBPACK FOOTER //
// ./src/components/BottomBar/Buttons/otherButtons.js